const isGusto = () => window.partner === "gusto" || window.location.pathname.slice(0, 6) === "/gusto";

export default isGusto;
